export const googleReviews = [
  {
    name: "Stephanie Everett",
    review:
      "If you’re looking for a great billing company to work with this company is it! I’m huge on customer service and they went above and beyond.",
    rating: 5,
    datePublished: "2026-03-16",
    source: "Google Reviews",
  },
  {
    name: "Lucas Morris",
    review:
      "The team is really professional and helpful. 100% recommended",
    rating: 4,
    datePublished: "2026-04-02",
    source: "Google Reviews",
  },
  {
    name: "Michael Trott",
    review:
      "They are really smart. 100% recommended if you are looking the best billing company",
    rating: 4,
    datePublished: "2026-04-02",
    source: "Google Reviews",
  },
];
